// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1ZHZJ","footer":"ModalInfo_footer__2hgOW"};